import {
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Inject,
  Input,
  Renderer2,
  TemplateRef,
  forwardRef
} from "@angular/core";

import {
  BaseOptionComponent,
  BaseSelectComponent,
  OptionLayoutContext
} from "../base";
import {
  SelectDropdownComponent,
  SingleSelectWithDropdownComponent
} from "./select-dropdown.component";

@Component({
  selector: "ta-select-option",
  template: `
    <div>
      <ng-template
        [ngTemplateOutlet]="optionLayoutTemplate"
        [ngTemplateOutletContext]="{ $implicit: option, model: option }"
      ></ng-template>
    </div>
  `
})
export class SelectDropdownOptionComponent<Model> extends BaseOptionComponent<
  Model
> {
  @Input()
  option: Model;

  @HostBinding("class.select__option--selected")
  get selected(): boolean {
    return this.selectElem.isSelected(this.option);
  }

  @HostBinding("class.select__option")
  get hostClass(): boolean {
    return true;
  }

  get optionLayoutTemplate(): TemplateRef<OptionLayoutContext<Model>> {
    return this.selectElem.optionLayoutTemplate;
  }

  constructor(
    @Inject(BaseSelectComponent)
    public selectElem: SingleSelectWithDropdownComponent<Model, any, any>,
    @Inject(forwardRef(() => SelectDropdownComponent))
    optionsList: any,
    elemRef: ElementRef,
    renderer: Renderer2
  ) {
    super(selectElem, optionsList, elemRef, renderer);
  }

  @HostListener("click", ["$event"])
  onClick(event: Event): void {
    this.selectElem.setSelected(this.option);
    this.selectElem.open = false;
  }

  @HostListener("mousemove", ["$event"])
  onMouseMove(): void {
    if (!this.optionsList.focusMouse || this.focused) {
      return;
    }
    this.optionsList.updateFocusedOption(this.option);
  }
}
